import type { ReactNode } from "react";
import { cn } from "@/lib/shared/utils";

// 進行中の文言。文字の上を光が流れ、スピナーなしで「今進んでいる」ことを示す。
// 待機領域のaria-busyとrole="status"は呼び出し側が領域単位で付ける。
export function PendingText({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <span className={cn("relative inline-block min-w-0", className)}>
      <span>{children}</span>
      <span aria-hidden="true" className="text-shimmer">
        {children}
      </span>
    </span>
  );
}
